import { useMemo } from 'react';

import { getPollStatuses } from '../resources/pollStatuses';
import type { PollType } from '../types';

export const usePollStatus = (poll: PollType | null, status?: string) =>
  useMemo(() => getPollStatuses(poll, status), [poll, status]);
